import useExperiment from 'hooks/common/use-experiment';

interface UseTest8112Return {
  /** Whether cat profile features should be enabled (treatment group) */
  isCatProfileEnabled: boolean;
  /** Loading state of the experiment */
  loading: boolean;
  /** The variant number (0 = control, 1 = treatment) */
  variant: number | undefined;
}

/**
 * Hook for A/B Test: Cat Dynamic UX Journey
 * Control group (variant 0): Shows only dog profiles
 * Treatment group (variant 1): Shows both cat and dog profiles
 * @see https://petsdeli.atlassian.net/browse/PT-8112
 */
const useTest8112 = (): UseTest8112Return => {
  const { variant, loading } = useExperiment({
    baseEntryId: '6vfg7B2q1VNFErbS2u8baV',
    shouldAddToHeader: true,
  });

  const isCatProfileEnabled = variant === 1;

  return {
    isCatProfileEnabled,
    loading,
    variant,
  };
};

export default useTest8112;
